import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DxpStorageService {
  clearLocalStorage = (): void => {
    localStorage.removeItem('dxp.currentProject');
    localStorage.removeItem('dxp.currentNodes');
    localStorage.removeItem('dxp.projects');
    localStorage.removeItem('dxp.rawNodesConfig');
    localStorage.removeItem('dxp.preloadUrls');
    localStorage.removeItem('dxp.contextSwitcherLabels');
  };

  clearLocalConfigStorage = (): void => {
    localStorage.removeItem('dxp.currentNodes');
    localStorage.removeItem('dxp.projects');
    localStorage.removeItem('dxp.rawNodesConfig');
    localStorage.removeItem('dxp.preloadUrls');
    localStorage.removeItem('dxp.contextSwitcherLabels');
  };
}
